import React, { useState, useEffect } from 'react';
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import { Form, Button, Container, Alert } from 'react-bootstrap';


const EditNSE = () => {
  //const editURL = "https://nseapi-fsaybmdxe6g4bkhv.eastasia-01.azurewebsites.net/api/";
  const editURL = "https://nseapi.maclogi.com/api/";
  //const editURL = "http://localhost:3000/api/";
  const navigate = useNavigate();

  const param = useParams();

  // add state for fields (if not already present)
  const [enterednseid, setNSEId] = useState('');
  const [enterednsedate, setNSEDate] = useState('');
  const [enterednseopen, setNSEOpen] = useState('');
  const [enterednsehigh, setNSEHigh] = useState('');
  const [enterednselow, setNSELow] = useState('');
  const [enterednseclose, setNSEClose] = useState('');
  const [enterednsebuy, setNSEBuy] = useState('');    // <- ensure this exists
  const [enterednsesell, setNSESell] = useState('');  // <- ensure this exists


  useEffect(() => {
    axios.get(editURL+ "nses/" +param.id).then((response) => {
      setNSEId(response.data[0].nseid);
      setNSEDate(response.data[0].nsedate);
      setNSEOpen(response.data[0].nseopen);
      setNSEHigh(response.data[0].nsehigh);
      setNSELow(response.data[0].nselow);
      setNSEClose(response.data[0].nseclose);
      setNSEBuy(response.data[0].nsebuy);
      setNSESell(response.data[0].nsesell);
    })
  },[]);


//     const nseidchangehandler = (event) => {
//       setNSEId(event.target.value);
//   };

//   const nsedatechangehandler = (event) => {
//     setNSEDate(event.target.value);
// };

// const nseopenchangehandler = (event) => {
//   setNSEOpen(event.target.value);
// };

// const nsehighchangehandler = (event) => {
//   setNSEHigh(event.target.value);
// };

// const nselowchangehandler = (event) => {
//   setNSELow(event.target.value);
// };

// const nseclosechangehandler = (event) => {
//   setNSEClose(event.target.value);
// };

// const nsebuychangehandler = (event) => {
//   setNSEBuy(event.target.value);
// };

// const nsesellchangehandler = (event) => {
//   setNSESell(event.target.value);
// };


  const submitActionHandler = (event) => {
    event.preventDefault();
    axios
    .put(editURL+ "nses/" +param.id, {
        nseid: enterednseid,
        nsedate: enterednsedate,
        nseopen: enterednseopen,
        nsehigh: enterednsehigh,
        nselow: enterednselow,
        nseclose: enterednseclose,
        nsebuy: enterednsebuy,
        nsesell: enterednsesell
      })
      .then((response) => {
        alert("NSE "+ param.id +" updated!");
        navigate('/nsedetails')

      }).catch(error => {
        alert("Error Ocurred updating nse:"+ error);
      });

  };

  const cancelHandler = () =>{
    navigate("/nsedetails");

  }
    return(
      <Alert variant='primary'>
      <Container>
        <Form onSubmit={submitActionHandler} nseid="data">
          <Form.Group controlId="form.nseid">
            <Form.Label>Id</Form.Label>
            <Form.Control type="text" value={enterednseid} readOnly />   {/* use readOnly */}
          </Form.Group>

          <Form.Group controlId="form.nsedate">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="text"
              value={enterednsedate}
              placeholder="Enter NSE Date"
              required
              onChange={e => setNSEDate(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="form.nseopen">
            <Form.Label>Open</Form.Label>
            <Form.Control
              type="text"
              value={enterednseopen}
              placeholder="Enter NSE Open"
              required
              onChange={e => setNSEOpen(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="form.nsehigh">
            <Form.Label>High</Form.Label>
            <Form.Control
              type="text"
              value={enterednsehigh}
              placeholder="Enter NSE High"
              required
              onChange={e => setNSEHigh(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="form.nselow">
            <Form.Label>Low</Form.Label>
            <Form.Control
              type="text"
              value={enterednselow}
              placeholder="Enter NSE Low"
              required
              onChange={e => setNSELow(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="form.nseclose">
            <Form.Label>Close</Form.Label>
            <Form.Control
              type="text"
              value={enterednseclose}
              placeholder="Enter NSE Close"
              required
              onChange={e => setNSEClose(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="form.nsebuy">
            <Form.Label>Buy</Form.Label>
            <Form.Control
              type="text"
              value={enterednsebuy}
              placeholder="Enter NSE Buy"
              required
              onChange={e => setNSEBuy(e.target.value)}    // <- make editable
            />
          </Form.Group>

          <Form.Group controlId="form.nsesell">
            <Form.Label>Sell</Form.Label>
            <Form.Control
              type="text"
              value={enterednsesell}
              placeholder="Enter NSE Sell"
              required
              onChange={e => setNSESell(e.target.value)}
            />
          </Form.Group>

          <br />
          <Button type='submit'>Save</Button>
          &nbsp;&nbsp;&nbsp;
          <Button type='button' onClick={()=>cancelHandler()}>Cancel</Button>  {/* Cancel should not be type='submit' */}
        </Form>
      </Container>
    </Alert>

    );
}
export default EditNSE;